import React from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

type QuillEditorProps = {
  value: string;
  onChange: (html: string) => void;
  placeholder?: string;
  className?: string;
  modules?: any;
  readOnly?: boolean;
};

const QuillEditor: React.FC<QuillEditorProps> = ({
  value,
  onChange,
  placeholder,
  className,
  modules,
  readOnly,
}) => {
  const resolvedModules =
    modules ?? (readOnly
      ? { toolbar: false }
      : {
          toolbar: [
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link"],
          ],
        });

  const rootClass = ["hlj-quill", className].filter(Boolean).join(" ");

  return (
    <>
      <style>{`
        .hlj-quill .ql-container {
          min-height: 260px;
        }
        .hlj-quill .ql-editor {
          min-height: 220px;
        }
        .hlj-quill .ql-editor table {
          border-collapse: collapse;
        }
        .hlj-quill .ql-editor table td,
        .hlj-quill .ql-editor table th {
          border: 1px solid #B3B3B3;
          padding: 4px 8px;
          color: #B3B3B3;
        }
      `}</style>
      <ReactQuill
        theme="snow"
        value={value ?? ""}
        onChange={(content) => onChange(content)}
        placeholder={placeholder}
        className={rootClass}
        modules={resolvedModules}
        readOnly={readOnly}
      />
    </>
  );
};

export default QuillEditor;
